//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CertificationRequirementType {
	Progress = 0,
	Z1 = 1,
	Exam = 2,
	Engagement = 3
}
